import React from 'react';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const VideoSpeedControls = ({
  isClickableDivHidden,
  speed,
  speedArray,
  changeVideoContainerStateProperty,
  playPause,
  setReferenceInVideoContainer
}) => {
  const icon = speed === 0 ? 'play' : 'pause';
  const variant = speed === 0 ? 'success' : 'primary';

  return (
    <>
      <InputGroup.Prepend>
        <Button variant={variant} disabled={isClickableDivHidden} onClick={playPause}>
          <FontAwesomeIcon icon={icon} />
        </Button>
      </InputGroup.Prepend>
      <Form.Control
        as="select"
        name="speed"
        ref={node => setReferenceInVideoContainer('speedSelect', node)}
        disabled={isClickableDivHidden}
        defaultValue={1}
        onChange={event => changeVideoContainerStateProperty('speed', Number(event.target.value))}
      >
        {map(speedArray, speedOption => (
          <option key={`x${speedOption}`} value={speedOption}>
            {`x${speedOption}`}
          </option>
        ))}
      </Form.Control>
    </>
  );
};

VideoSpeedControls.propTypes = {
  isClickableDivHidden: PropTypes.bool.isRequired,
  speed: PropTypes.number.isRequired,
  speedArray: PropTypes.array.isRequired,
  changeVideoContainerStateProperty: PropTypes.func.isRequired,
  playPause: PropTypes.func.isRequired,
  setReferenceInVideoContainer: PropTypes.func.isRequired
};

export default VideoSpeedControls;
